module.exports = __webpack_public_path__ + "img/logo.9545f285.svg";